<template>
  <ConfiguratorLevel1Mobile v-if="$store.getters.isMobile" />
  <ConfiguratorLevel1Desktop v-else />
</template>

<script>
import ConfiguratorLevel1Desktop from '@/views/step1/ConfiguratorLevel1Desktop';
import ConfiguratorLevel1Mobile from '@/views/step1/ConfiguratorLevel1Mobile';
import { loadingMixin } from '@/mixins/LoadingMixin';
import { logicMixin } from '@/mixins/LogicMixin';
import { TrackingMixin } from '@/mixins/TrackingMixin';

export default {
  components: {
    ConfiguratorLevel1Desktop,
    ConfiguratorLevel1Mobile,
  },
  mixins: [loadingMixin, logicMixin, TrackingMixin],
  mounted: function () {
    this.$store.commit('setRedirectCon', true);
    this.$store.commit('setCurrentLevel', 1);
  },
  watch: {
    $route(to, from) {
      this.init();
    },
  },
  methods: {
    init: function () {
      this.$store.commit('setModalOpen', false);
      if (this.$route.params.id) {
        this.$store.getters.getListItemsLevel1.forEach((item) => {
          if (item.id === parseInt(this.$route.params.id)) {
            this.$store.commit('setSelectedItem', item);
            this.$root.$emit('level1Selected');
            this.doReplace();
            if (this.$store.getters.getDontSwitchView) {
              this.$store.commit('setDontSwitchView', false);
            } else {
              this.$root.$emit('boxPreviewInside');
            }
          }
        });
      } else {
        this.$store.commit('setSelectedItem', null);
        this.$root.$emit('level1Selected');
        this.doReplace();
      }

      this.criteoTracking({
        event: 'viewList',
        item: this.$store.getters.getListItemsLevel1Filtered.map(product => product.id.toString()),
        category: 'Level 1',
        keywords: ''
      });
    },
  },
  jsonld() {
    if (
      this.$store.getters.getSelectedItem.data === null ||
      this.$store.getters.getSelectedItem.data.id === undefined
    ) {
      return {};
    }
    return {
      '@context': 'http://schema.org/',
      '@type': 'Product',
      sku: this.$store.getters.getSelectedItem.data.id.toString(),
      mpn: this.$store.getters.getSelectedItem.data.id.toString(),
      image: this.$store.getters.getSelectedItem.data.photos.b2c[0].sd,
      name: this.$store.getters.getSelectedItem.data.name,
      description: this.$store.getters.getSelectedItem.data.description,
      brand: {
        '@type': 'Thing',
        name: 'Componata',
      },
      audience: {
        '@type': 'PeopleAudience',
        suggestedGender: 'unisex',
      },
      offers: {
        '@type': 'Offer',
        priceCurrency: 'EUR',
        price: this.getPriceRaw(
          this.$store.getters.getSelectedItem.data
        ).toString(),
        itemCondition: 'http://schema.org/NewCondition',
        availability: 'http://schema.org/InStock',
      },
    };
  },
  metaInfo () {
    return {
      title: 'Fertige Präsente'
    };
  }
};
</script>

<style lang="scss">
@import '../../assets/styles/views/level';
</style>
